import { render, staticRenderFns } from "./filogix-loader.vue?vue&type=template&id=93dac8a4"
import script from "./filogix-loader.vue?vue&type=script&lang=js"
export * from "./filogix-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports